<script setup lang="ts">
import type { CounterProps } from "./Counter.props"

withDefaults(defineProps<CounterProps>(), {
  isStepper: false,
  isActive: true,
  isCompleted: false
})
</script>

<template>
  <div
    v-if="counter"
    class="
      badge-counter
      mouse-bold
      box-content
      flex
      items-center
      justify-center
      rounded-full
      text-white
    "
    :class="[
      !isStepper ? 'h-5 w-5 hover:bg-green-70' : 'h-6 w-6 md:h-8 md:w-8 ',
      isActive && !isStepper ? 'border-none' : 'border-4 border-green-10',
      isActive
        ? 'border-4 border-green-10 bg-green-main'
        : 'border-none text-black-40 ',

      { 'border-none bg-green-main': isCompleted },

      { ' bg-grey-main': !isActive && !isCompleted }
    ]"
  >
    <IconsCheckmark v-show="isCompleted" class="h-5 w-5 text-white" />
    <span v-show="!isCompleted">{{ counter }} </span>
  </div>
</template>
